import { CodedStatusMessage } from '@core/models/coded-status-message.model';
import { GbeErrorCodes } from '@core/models/gbe/gbe-error-codes.enum';
import { normalize } from '@core/services/gbe-error-parser/warning-normalizer';

/**
 * DataLayer's own prose for each compatibility refusal in a failed save. The refusal carries no
 * details and names no requirement, so the prose is all there is to show, and only on the field.
 */
export function compatibilityFieldErrors(error: CodedStatusMessage | null): string[] {
  if (!error) {
    return [];
  }
  return normalize(error)
    .filter((entry) => entry.code === GbeErrorCodes.ENTITY_FILTER_ERROR)
    .map((entry) => entry.message);
}
